import { Col } from 'reactstrap'
import { H3 } from '../../../../AbstractElements'
import { LightBackground } from '../../../../utils/Constant'
import { lightBackgroundData } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'

const LightBackgrounds = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H3 className="mb-3">{LightBackground}</H3>
        <div className="helper-common-box">
          <div className="helper-box alert-light-primary"> </div>.alert-light-primary
        </div>
        {lightBackgroundData.map((item, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box alert-light-${item}`}> </div>.alert-light-{item}
          </div>
        ))}
      </div>
    </Col>
  )
}

export default LightBackgrounds